import {
  RiPhoneLine, RiPhoneFill,
  RiWhatsappLine, RiWhatsappFill,
  RiMailLine, RiMailFill,
  RiArrowRightSLine, RiArrowRightLine, RiArrowLeftLine,
  RiHomeLine, RiListCheck,
  RiMenu3Line, RiCloseLine,
  RiSearchEyeLine, RiTimeLine, RiTimeFill,
  RiMapPin2Line, RiMapPin2Fill, RiMapPinLine,
  RiShieldCheckLine, RiSubtractLine, RiAddLine,
  RiAwardLine, RiTeamLine,
  RiBuilding2Line, RiCalendarCheckLine, RiStarLine, RiMedalLine,
  RiZoomInLine, RiCheckLine,
  RiCustomerService2Line,
  RiSunLine, RiLayoutTopLine, RiWindowLine,
} from "@remixicon/react";

const iconMap: Record<string, React.FC<{ className?: string; size?: number }>> = {
  "ri-phone-line": RiPhoneLine,
  "ri-phone-fill": RiPhoneFill,
  "ri-whatsapp-line": RiWhatsappLine,
  "ri-whatsapp-fill": RiWhatsappFill,
  "ri-mail-line": RiMailLine,
  "ri-mail-fill": RiMailFill,
  "ri-arrow-right-s-line": RiArrowRightSLine,
  "ri-arrow-right-line": RiArrowRightLine,
  "ri-arrow-left-line": RiArrowLeftLine,
  "ri-home-line": RiHomeLine,
  "ri-list-check": RiListCheck,
  "ri-menu-3-line": RiMenu3Line,
  "ri-close-line": RiCloseLine,
  "ri-search-eye-line": RiSearchEyeLine,
  "ri-time-line": RiTimeLine,
  "ri-time-fill": RiTimeFill,
  "ri-map-pin-2-line": RiMapPin2Line,
  "ri-map-pin-2-fill": RiMapPin2Fill,
  "ri-map-pin-line": RiMapPinLine,
  "ri-shield-check-line": RiShieldCheckLine,
  "ri-subtract-line": RiSubtractLine,
  "ri-add-line": RiAddLine,
  "ri-award-line": RiAwardLine,
  "ri-team-line": RiTeamLine,
  "ri-building-2-line": RiBuilding2Line,
  "ri-calendar-check-line": RiCalendarCheckLine,
  "ri-star-line": RiStarLine,
  "ri-medal-line": RiMedalLine,
  "ri-zoom-in-line": RiZoomInLine,
  "ri-check-line": RiCheckLine,
  "ri-customer-service-2-line": RiCustomerService2Line,
  "ri-sun-line": RiSunLine,
  "ri-layout-top-line": RiLayoutTopLine,
  "ri-window-line": RiWindowLine,
};

export default function Icon({ name, className, size }: { name: string; className?: string; size?: number }) {
  const Comp = iconMap[name];
  if (!Comp) return null;
  return <Comp className={className} size={size ?? 16} />;
}
